\<template>
  <div class="left-side-menu">

    <div class="slimscroll-menu">

      <router-link to="/" class="logo text-center mb-4">
        <span class="logo-lg">
            <img src="/static/logo.png" height="64" width="64">
        </span>
        <span class="logo-sm">
            <img src="/static/logo_sm.png" height="32">
        </span>
        <h4 class="env">{{$store.state.env}}</h4>
      </router-link>

      <ul class="nav metismenu side-nav" id="metismenu">
        <li class="side-nav-title side-nav-item">4U Logistics</li>

        <li class="side-nav-item">
          <router-link to="/new-clients" class="side-nav-link">
            <i class="mdi mdi-account-group"></i>
            <span>Kliendid</span>
          </router-link>
        </li>
        <li class="side-nav-item" id="show-declarations">
          <router-link to="/declarations" class="side-nav-link">
            <i class="mdi mdi-file-document"></i>
            <span>Deklaratsioonid</span>
          </router-link>
        </li>
        <li class="side-nav-item">
          <router-link to="/invoices" class="side-nav-link">
            <i class="mdi mdi-receipt"></i>
            <span>Arved</span>
          </router-link>
        </li>
        <li class="side-nav-item">
          <router-link to="/pricelist" class="side-nav-link">
            <i class="mdi mdi-currency-eur"></i>
            <span>Üldine hinnakiri</span>
          </router-link>
        </li>
        <li class="side-nav-item">
          <router-link to="/debts" class="side-nav-link">
            <i class="mdi mdi-emoticon-sad"></i>
            <span>Võlglased</span>
          </router-link>
        </li>
        <li class="side-nav-item">
          <router-link to="/limit-exceeded" class="side-nav-link">
            <i class="mdi mdi-clock-alert"></i>
            <span>Krediidilimiit ületatud</span>
          </router-link>
        </li>
        <li class="side-nav-item">
          <router-link to="/transactions" class="side-nav-link">
            <i class="mdi mdi-inbox-arrow-down"></i>
            <span>Laekumiste logi</span>
          </router-link>
        </li>

        <li class="nav side-nav-item">
          <a href="#" class="side-nav-link">
            <i class="mdi mdi-inbox-arrow-down"></i>
            <span>Raportid</span>
          </a>
          <ul class="side-nav-second-level mm-collapse">
            <li>
              <router-link to="/tollreport">
                <span>Tolliarve kontroll</span>
              </router-link>
            </li>
            <li>
              <router-link to="/servicereport">
                <span>Teenuste raport</span>
              </router-link>
            </li>
          </ul>
        </li>
        <permission :name="['Users','Services','Classifiers']">
          <li class="nav side-nav-item">
            <a href="#" class="side-nav-link">
              <i class="mdi mdi-settings"></i>
              <span>Haldus</span>
            </a>
            <ul class="side-nav-second-level mm-collapse">
              <permission name="Users">
                <li>
                  <router-link to="/admin/users">
                    <i class="mdi mdi-account-edit"></i>
                    <span>Kasutajad</span>
                  </router-link>
                </li>
              </permission>
              <permission name="Services">
                <li>
                  <router-link to="/admin/services">
                    <i class="mdi mdi-hexagon-outline"></i>
                    <span>Teenused</span>
                  </router-link>
                </li>
              </permission>
              <permission name="Classifiers">
                <li>
                  <router-link to="/admin/classifiers">
                    <i class="mdi mdi-library-books"></i>
                    <span>Klassifikaatorid</span>
                  </router-link>
                </li>
              </permission>
            </ul>
          </li>
        </permission>
      </ul>

      <div class="clearfix"></div>

    </div>

  </div>
</template>

<script>

  export default {
    name: "LeftSidebar",
    data() {
      return {
        reportMenu: false
      }
    },
    mounted() {
      let component = this;
      $('.button-menu-mobile').on('click', function (event) {
        event.preventDefault();
        $("body").toggleClass('sidebar-enable')
        component.resetSidebarScroll();
      });

      $("#metismenu").metisMenu();

      component.resetSidebarScroll();

      $(document).on('click', '.left-side-menu a', function () {
        let mobileMode = $('.button-menu-mobile:visible').length
        if (mobileMode) {
          $("body").toggleClass('sidebar-enable')
        }
      })
    },
    methods: {
      resetSidebarScroll() {
        $('.slimscroll-menu').slimscroll({
          height: 'auto',
          position: 'right',
          size: "8px",
          color: '#9ea5ab',
          wheelStep: 5,
          touchScrollStep: 20
        });
      }
    },
  }
</script>
